import { WindowRef } from '@aifs-shared/framework/window-ref';
import { NavbarComponent } from '@aifs-shared/navbar/navbar.component';
import { UserMenuComponent } from '@aifs-shared/navbar/user-menu.component';
import { UserService } from '@aifs-shared/user/user.service';

import { Component, computed, inject, Signal, signal, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NavbarComponent, UserMenuComponent],
    templateUrl: './app.html',
    styleUrl: './app.scss'
})
export class App {
    protected readonly title = signal('Camp America');

    private userService = inject(UserService);
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private windowRef = inject(WindowRef);

    @ViewChild('navbar', { static: false }) navbar!: NavbarComponent;

    isSignedIn = computed(() => this.userService.isLoggedIn());
    isApplicant = computed(() => this.userService.isApplicant());
    isProduction = false;
    userIsNotGuest = computed(() => !this.userService.isGuest());

    constructor() {
        this.isProduction = environment.production;
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home'
    }

    ngOnInit() {
        this.routeSubscription = this.router.events.subscribe(
            (evt) => {
                if (!(evt instanceof NavigationEnd)) {
                    return
                }
                this.windowRef.scrollToTop();
            }
        );
    }

    ngOnDestroy() {
        this.routeSubscription?.unsubscribe();
    }

    toggleSideMenu() {
        this.opened = !this.opened;
        if (this.navbar) {
            this.navbar.closeMenu();
        }
    }

    navigateTo(url: string): void {
        this.opened = false;
        if (this.navbar) {
            this.navbar.closeMenu();
        }

        this.router.navigateByUrl(url);
    }

    onPageClick(event: MouseEvent) {
        this.opened = false;
        if (this.navbar) {
            this.navbar.closeMenu();
        }
        event.stopPropagation();
    }

    returnUrl = '';
    opened = false;

    routeSubscription?: Subscription;
}
